import React, { Component } from "react";
import GroupCriticalIllness from "./GroupCriticalIllness/GroupCriticalIllness";
import GroupHealth from "./GroupHealth/GroupHealth";
import GroupPersonalAccident from "./GroupPersonalAccident/GroupPersonalAccident";
import GroupTerm from "./GroupTerm/GroupTerm";
import GroupTravelInsurance from "./GroupTravelInsurance/GroupTravelInsurance";
import Insurers from "./Insurers/Insurers";
import Settings from "./Settings/Settings";
import VoluntaryPlans from "./VoluntaryPlans/VoluntaryPlans";
import GroupSuperTopup from "./GroupSuperTopup/GroupSuperTopup";
import Tpa from "./Tpa/Tpa";
interface Props {
  pageStatus: string;
}

const ProductConfig: React.FC<Props> = ({ pageStatus }) => {
  return (
    <div>
      {pageStatus == "groupHealth" ? <GroupHealth /> : null}
      {pageStatus == "groupTerm" ? <GroupTerm /> : null}
      {pageStatus == "groupPersonalAccident" ? <GroupPersonalAccident /> : null}
      {pageStatus == "groupCriticalIllness" ? <GroupCriticalIllness /> : null}
      {pageStatus == "groupTravel" ? <GroupTravelInsurance /> : null}
      {pageStatus == "voluntaryPlans" ? <VoluntaryPlans /> : null}
      {pageStatus == "insurers" ? <Insurers /> : null}
      {pageStatus == "tpa" ? <Tpa /> : null}
      {pageStatus == "settings" ? <Settings /> : null}
      {pageStatus == "superTopup" ? <GroupSuperTopup /> : null}
    </div>
  );
};

export default ProductConfig;
